"use client";

import { useEffect } from "react";

export const usePreventBackNavigation = (shouldPrevent = true) => {
  useEffect(() => {
    if (!shouldPrevent) return;

    // Add a dummy state to history to prevent going back
    const preventBack = () => {
      window.history.pushState(null, "", window.location.href);
    };

    // Handle popstate (back button)
    const handlePopState = (event) => {
      event.preventDefault();
      // Push the current state again to prevent going back
      window.history.pushState(null, "", window.location.href);
    };

    // Handle beforeunload (page refresh/close)
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue =
        "Are you sure you want to leave? Your payment session will be lost.";
      return event.returnValue;
    };

    // Initial setup
    preventBack();

    // Add event listeners
    window.addEventListener("popstate", handlePopState);
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup
    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldPrevent]);
};
